import { ReactComponent as AndroidIcon } from '../assets/platforms/android.svg';
import { ReactComponent as AppleIcon } from '../assets/platforms/apple.svg';
import { ReactComponent as PwaIcon } from '../assets/platforms/pwa.svg';

export const platformsItems = [AppleIcon, PwaIcon, AndroidIcon];
